import React, { FC, useEffect, useRef, useState } from 'react';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { CtaStylesCtaTypeObj, TGenericPopUpProps } from './types/genericPopUp.types';
import { documentService } from '../../../utils/window.utils.js';
import { PropsFromGenericPopup } from '../../../types/types';
import UnreleasedComponent from '../unreleasedComponent';
import CTA from '../cta';
import Icon from '../icon';
import ModalDialog from '../modalDialog';
import { adjustModalPositionBasedOnContent } from '../../../utils/modal.utils';
import { GenericPopUpContext } from '../genericPopUpContextProvider';

const SharedGenericPopUp: FC<TGenericPopUpProps> = (props) => {
  //There is an issue in Sitecore because of which the params isn't loaded on load. So hardcoded for now but will remove later
  const { children, extraClassName = '' } = props;
  const ctaText = props?.params?.ctaText || 'Generic Pop Up';
  const isEEActive = props?.sitecoreContext?.pageEditing;
  const [isPopUpShown, setIsPopUpShown] = useState(false);
  const editorRef = useRef<HTMLDivElement | null>(null);
  const ctaOpenTriggerRef = useRef<HTMLDivElement | null>(null);
  const ctaCloseTriggerRef = useRef<HTMLDivElement | null>(null);
  const popUpClassName = 'generic-modal-dialog';
  const modalDialogConatinerClass = 'modal-dialog__overlay';
  const modalDialogContentlass = 'modal-dialog';
  const modalDialogCloseBtnClass = 'modal-dialog__close-button';

  useEffect(() => {
    if (isEEActive) {
      const startStopBodyScroll = (isScrollable: boolean): void => {
        const docElement = documentService();
        if (!docElement?.body) return;
        return isScrollable ? docElement.body.classList.remove('body--with-pop-up') : docElement.body.classList.add('body--with-pop-up');
      };

      const openCTA = (event): void => {
        if (event.ctrlKey || event.metaKey) {
          event?.stopPropagation();
          event?.preventDefault();
          editorRef.current?.classList.add('editor_popup--visible');
          startStopBodyScroll(false);
        }
      };
      const closeCTA = (event): void => {
        if (event.ctrlKey || event.metaKey) {
          event?.stopPropagation();
          event?.preventDefault();
          editorRef.current?.classList.remove('editor_popup--visible');
          startStopBodyScroll(true);
        }
      };
      ctaOpenTriggerRef.current?.addEventListener('click', openCTA);
      ctaCloseTriggerRef.current?.addEventListener('click', closeCTA);

      return () => {
        ctaOpenTriggerRef.current?.removeEventListener('click', openCTA); // eslint-disable-line
        ctaCloseTriggerRef.current?.removeEventListener('click', closeCTA); // eslint-disable-line
      };
    }
  }, []); // eslint-disable-line

  const propsToInnerComp: PropsFromGenericPopup = {
    isInGenericPopup: true,
  };

  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <div className={`generic-popup ${extraClassName}`}>
      <div className="generic-popup__button" ref={ctaOpenTriggerRef} onClick={(): void => setIsPopUpShown(true)}>
        {children ? children :
          <CTA type={CtaStylesCtaTypeObj[props.params?.ctaStyles || 'Primary Red']}>{ctaText}</CTA>
        }
      </div>

      {/* Pop up UI for Editor */}
      <div
        className={`${modalDialogConatinerClass} ${popUpClassName} editor_popup`}
        ref={editorRef}
        style={{ display: isEEActive ? 'block' : 'none' }}
      >
        <div className={`${modalDialogCloseBtnClass} editor_popup__close`} ref={ctaCloseTriggerRef}>
          <Icon iconName="action-close" size={24} extraClassName="editor_popup__close-icon" />
        </div>
        <div className={`${modalDialogContentlass} ${popUpClassName} editor_popup__content`}>
          {props.rendering && <Placeholder name={'jss-popup'} rendering={props.rendering} {...propsToInnerComp} />}
        </div>
      </div>

      {props.rendering && (
        <ModalDialog
          isOpen={!isEEActive && isPopUpShown}
          className={popUpClassName}
          close={(): void => setIsPopUpShown(false)}
          onAfterOpen={adjustModalPositionBasedOnContent}
        >
          <GenericPopUpContext.Provider value={{ isGenericPopUp: true }}>
            <Placeholder name={'jss-popup'} rendering={props.rendering} {...propsToInnerComp} />
          </GenericPopUpContext.Provider>
        </ModalDialog>
      )}
    </div>
  );
};

export default withSitecoreContext()(SharedGenericPopUp);
